import { FaultData } from "@fairfleet/geotab";
import { DiagnosticAddinData } from "@/pages/diagnostic-edit/models/DiagnosticAddinData";
import { resolveDiagnosticOverride } from "@/pages/diagnostic-edit/utils/resolveDiagnosticOverride";

export const faultComparator =
  (descriptions: DiagnosticAddinData[], deviceGroupIds: string[] = []) =>
  (a: FaultData, b: FaultData) => {
    const descA = resolveDiagnosticOverride(descriptions, a.diagnostic.id, deviceGroupIds);
    const descB = resolveDiagnosticOverride(descriptions, b.diagnostic.id, deviceGroupIds);

    const priorityA = descA ? descA.priority : 0;
    const priorityB = descB ? descB.priority : 0;

    if (priorityA !== priorityB) {
      return priorityB - priorityA;
    }

    return b.dateTime.getTime() - a.dateTime.getTime();
  };
